import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthProvider";
import MatchBotLoader from "../components/ui/MatchBotLoader";

export default function ProtectedRoute({ children, roles }) {
  const { session, profile, loading } = useAuth();
  const location = useLocation();

  console.log("[ProtectedRoute] render", { session, profile, loading, roles });

  const isAuthLoading = loading && !session;
  const isProfileLoading = !!session && !!roles && !profile;

  // Solo bloqueamos mientras existe una espera real. El branding no debe
  // demorar artificialmente el acceso de un usuario que ya está autenticado.
  if (isAuthLoading || isProfileLoading) {
    return <MatchBotLoader />;
  }

  // Si no hay sesión -> Login
  if (!session) {
    console.log("[ProtectedRoute] no session → /login");
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location.pathname + location.search }}
      />
    );
  }

  // Si no tiene permisos -> Home
  if (roles && !roles.includes(profile?.role)) {
    console.log("[ProtectedRoute] role not allowed", {
      have: profile?.role,
      needed: roles,
    });
    return <Navigate to="/" replace />;
  }

  return children;
}
